import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EmployerDto } from 'src/app/api/exa';
import { EmployerService } from 'src/app/services/employer.service';
import { EmployerAddDialogComponent } from '../employer-add-dialog/employer-add-dialog.component';
import { MachineService } from 'src/app/services/machine.service';
import { StorageService } from '../../services/storage.service';


@Component({
  selector: 'app-employer-select-dialog',
  templateUrl: './employer-select-dialog.component.html',
  styleUrls: ['./employer-select-dialog.component.scss'],
})
export class EmployerSelectDialogComponent implements OnInit, OnDestroy {
  employers: EmployerDto[] = [];
  selected: EmployerDto = null;

  private terminate$: Subject<void> = new Subject();
  constructor(
    private log: NGXLogger,
    private employerService: EmployerService,
    private machineService: MachineService,    
    private storage: StorageService,
    private modalController: ModalController
  ) {
   
  }

  ngOnInit() {
    this.employerService
    .onGetEmployers()
    .pipe(takeUntil(this.terminate$))
    .subscribe(
      (ret) => {
        this.employers = ret;
      },
      (err) => {
        this.employers = [];
      }
    );
  this.employerService
    .onSelectEmployer()
    .pipe(takeUntil(this.terminate$))
    .subscribe(
      (ret) => {
        this.selected = ret;
        console.log(this.selected);
        
        
      },
      (err) => {
        this.selected = null;
      }
    );
  }

  ngOnDestroy(): void {
    this.terminate$.next();
    this.terminate$.complete();
  }
  onClickOk() {
    this.modalController.dismiss({
      selected: false,
    });
  }

  onSelectEmployer(item: EmployerDto) {
    sessionStorage.setItem(this.selected.username + ' ' + 'onlinesMachinesWhenLeaving', JSON.stringify(this.machineService.onlinesMachinesWhenLeaving));
    localStorage.setItem(this.selected.username + 'timeWhenLeaving', JSON.stringify(Date.now()));
    this.employerService.setSelectedEmployer(item.username);
    this.modalController.dismiss({
      selected: false,
    });
    this.storage.set('lastEmployerSelected', this.selected.username);
    localStorage.removeItem('mapLat');
    localStorage.removeItem('mapLng');
    localStorage.removeItem('mapZoom');
    localStorage.removeItem('bounds');
    localStorage.removeItem('bounds2');
  }

  async addNewEmployer() {
    const modal = await this.modalController.create({
      component: EmployerAddDialogComponent,
      cssClass: 'custom-dialog h-300',
    });
    await modal.present();
  }

  handleRefresh(event) {
    setTimeout(() => {
      // Any calls to load data go here
      this.employerService
      .onGetEmployers()
      .pipe(takeUntil(this.terminate$))
      .subscribe(
        (ret) => {
          this.employers = ret;
          console.log(this.employers);
        },
        (err) => {
          this.employers = [];
        }
      );
      event.target.complete();
    }, 2000);
  }
}
